module.exports = __webpack_public_path__ + "img/no-sound.7f4ac022.svg";